/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgObjectS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16 5a3 3 0 1 1 1.714 2.711L16 9.426v2.28a4.57 4.57 0 0 0-1.763 1.464l-.008.01-.008.012a4.2 4.2 0 0 0-.221.355V10h-4v4h3.783a4.588 4.588 0 0 0-.327 1.736c0 .088.002.176.006.264h-4.06l-1.698 1.699a3 3 0 1 1-1.418-1.41L8 14.574V9.426L6.286 7.71A3 3 0 1 1 7.704 6.3L9.403 8h5.194l1.7-1.699A2.99 2.99 0 0 1 16 5zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM5 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm10.576 2.02v1.668c.192.096.444.18.756.252a10.22 10.22 0 0 0 2.112.228c1.056 0 1.872-.236 2.448-.708.584-.472.876-1.116.876-1.932 0-.664-.164-1.188-.492-1.572-.328-.392-.884-.724-1.668-.996l-.912-.312c-.52-.176-.876-.332-1.068-.468a.671.671 0 0 1-.276-.552c0-.584.496-.876 1.488-.876.36 0 .752.044 1.176.132.424.08.84.2 1.248.36v-1.668a4.95 4.95 0 0 0-1.128-.336 6.36 6.36 0 0 0-1.296-.132c-.696 0-1.296.108-1.8.324-.504.208-.896.508-1.176.9-.272.392-.408.86-.408 1.404 0 .632.168 1.152.504 1.56.344.4.888.728 1.632.984l.912.312c.528.176.884.336 1.068.48a.618.618 0 0 1 .276.516c0 .296-.144.528-.432.696s-.684.252-1.188.252c-.848 0-1.732-.172-2.652-.516z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgObjectS as ObjectS };
